import styled from "styled-components";

export const ClientsContainer = styled.section`
  padding: 100px 0;
  @media (max-width:${({theme}) => theme.breakpoint.hd}) {
    padding: 90px 0;
  }
  @media (max-width:${({theme}) => theme.breakpoint.large}) {
    padding: 75px 0;
  }
  @media (max-width:${({theme}) => theme.breakpoint.default}) {
    padding: 64px 0;
  }
  @media (max-width:${({theme}) => theme.breakpoint.medium}) {
    padding: 52px 0;
  }
  @media (max-width:${({theme}) => theme.breakpoint.tab}) {
    padding: 60px 0;
  }
  @media (max-width:${({theme}) => theme.breakpoint.mobile}) {
    padding: 32px 0;
  }
`;

export const HeadingTitle = styled.h2`
  width: 210px;
  @media (max-width:${({theme}) => theme.breakpoint.default}) {
    width: 130px;
  }
  @media (max-width:${({theme}) => theme.breakpoint.tab}) {
    margin-left: 80px;
  }
  @media (max-width:${({theme}) => theme.breakpoint.mobile}) {
    margin-left: 60px;
  }
`;

export const GlobeSection = styled.div`
  margin-bottom: 50px;
  position: relative;
  text-align: center;
  top: -50px;
  @media (max-width:${({theme}) => theme.breakpoint.default}) {
    top: -36px;
  }
  @media (max-width:${({theme}) => theme.breakpoint.medium}) {
    top: -20px;
  }
  @media (max-width:${({theme}) => theme.breakpoint.tab}) {
    margin-top: 50px;
    top: 0;
  }
  @media (max-width:${({theme}) => theme.breakpoint.mobile}) {
    margin-top: 32px;
    top: 0;
  }
`;

export const Image = styled.img`
  width: 1200px;
  @media (max-width:${({theme}) => theme.breakpoint.hd}) {
    width: 1060px;
  }
  @media (max-width:${({theme}) => theme.breakpoint.large}) {
    width: 900px;
  }
  @media (max-width:${({theme}) => theme.breakpoint.default}) {
    width: 760px;
  }
  @media (max-width:${({theme}) => theme.breakpoint.medium}) {
    width: 640px;
  }
  @media (max-width:${({theme}) => theme.breakpoint.tab}) {
    margin: 0 auto;
    width: 80%;
  }
  @media (max-width:${({theme}) => theme.breakpoint.mobile}) {
    width: 320px;
  }
`;

export const ClientsCarousel = styled.div`
  margin-left: auto;
  width: 1400px;
  @media (max-width:${({theme}) => theme.breakpoint.hd}) {
    width: 1220px;
  }
  @media (max-width:${({theme}) => theme.breakpoint.large}) {
    width: 1060px;
  }
  @media (max-width:${({theme}) => theme.breakpoint.default}) {
    width: 920px;
  }
  @media (max-width:${({theme}) => theme.breakpoint.medium}) {
    width: 760px;
  }
  @media (max-width:${({theme}) => theme.breakpoint.tab}) {
    width: calc(100% - 80px);
  }
  @media (max-width:${({theme}) => theme.breakpoint.mobile}) {
    width: calc(100% - 60px);
  }
`;

export const CarouselItems = styled.div`
  border-right: 1px solid ${({theme}) => theme.colors.dark};
  padding: 20px 40px;
  @media (max-width:${({theme}) => theme.breakpoint.hd}) {
    padding: 16px 32px;
  }
  @media (max-width:${({theme}) => theme.breakpoint.large}) {
    padding: 12px 24px;
  }
  @media (max-width:${({theme}) => theme.breakpoint.default}) {
    padding: 10px 20px;
  }
  @media (max-width:${({theme}) => theme.breakpoint.medium}) {
    padding: 8px 16px;
  }
  @media (max-width:${({theme}) => theme.breakpoint.mobile}) {
    border-right: 2px solid ${({theme}) => theme.colors.dark};
    padding: 5px 5px;
    padding-right: 15px;
  }
`;

export const ImgIcon = styled.img`
  height: 90px;
  @media (max-width:${({theme}) => theme.breakpoint.hd}) {
    height: 80px;
  }
  @media (max-width:${({theme}) => theme.breakpoint.large}) {
    height: 68px;
  }
  @media (max-width:${({theme}) => theme.breakpoint.default}) {
    height: 56px;
  }
  @media (max-width:${({theme}) => theme.breakpoint.medium}) {
    height: 50px;
  }
`;
